import React from 'react';
import PropTypes from 'prop-types';
import { UiIcon } from 'ui-components';
import { useSelector } from 'react-redux';
import Loading from 'components/loading/Loading';

export function SelectedResourceList(props) {
  const { selectedItems, onSelectedResourceRemove } = props;
  const selectedResources = useSelector(
    (state) => state.resourceReducer.selectedResources
  );
  const selectedResourcesLoading = useSelector(
    (state) => state.resourceReducer.selectedResourcesLoading
  );

  const handleRemoveResourceTag = (id) => {
    onSelectedResourceRemove(id);
  };

  return (
    <div className='selected-resources'>
      <div className='resources flex'>
        {selectedResourcesLoading && (
          <div className='h-20 flex center w-full'>
            <Loading spinning={true}></Loading>
          </div>
        )}
        {!selectedResourcesLoading &&
          Object.keys(selectedItems).map((tagId) => (
            <span className='resource flex' key={tagId}>
              {selectedResources?.[tagId]?.title ||
                selectedItems?.[tagId].title}
              <UiIcon
                icon='ri-close-line'
                onClick={() => handleRemoveResourceTag(selectedItems[tagId])}
              />
            </span>
          ))}
      </div>
    </div>
  );
}

SelectedResourceList.propTypes = {
  selectedItems: PropTypes.object,
  onSelectedResourceRemove: PropTypes.func,
};
